var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "united-kingdom",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M0 85.333h512V426.67H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M393.785 315.358 512 381.034v-65.676zM311.652 315.358 512 426.662v-31.474l-143.693-79.83zM458.634 426.662l-146.982-81.664v81.664z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M90.341 315.356 0 365.546v-50.19zM200.348 329.51v97.151H25.491z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M143.693 315.358 0 395.188v31.474l200.348-111.304z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M118.215 196.634 0 130.958v65.676zM200.348 196.634 0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M421.659 196.636 512 146.446v50.19zM311.652 182.482V85.331h174.857z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M368.307 196.634 512 116.804V85.33L311.652 196.634z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.6a8d4dc4b349fdb464c3c79926747611.svg";
export { ForwardRef as ReactComponent };